var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Credit_Card"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credit_Card",
    "data-name": "Credit Card",
    clipPath: "url(#clip-Credit_Card)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card_12503090",
    transform: "translate(-2 3.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M94.017,9.98H27.767a8,8,0,0,0-8,7.983V27.6H9.983A8,8,0,0,0,2,35.58V75.4A8,8,0,0,0,9.983,83.38H76.25A8,8,0,0,0,84.233,75.4V65.763h9.783A8,8,0,0,0,102,57.78V17.963A8,8,0,0,0,94.017,9.98ZM9.983,30.93H76.25a4.663,4.663,0,0,1,4.65,4.65v2.5H5.333v-2.5a4.652,4.652,0,0,1,4.65-4.65ZM80.9,75.4a4.673,4.673,0,0,1-4.65,4.65H9.983a4.663,4.663,0,0,1-4.65-4.65v-23H80.9Z",
    transform: "translate(0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M24.27,39.5H14.553A4.837,4.837,0,0,0,9.72,44.333v4.95A4.833,4.833,0,0,0,14.553,54.1H24.27a4.83,4.83,0,0,0,4.817-4.817v-4.95A4.833,4.833,0,0,0,24.27,39.5Z",
    transform: "translate(5.147 19.68)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M51.507,45.15H30.957a1.667,1.667,0,1,0,0,3.333h20.55a1.667,1.667,0,1,0,0-3.333Z",
    transform: "translate(18.193 23.447)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M51.507,40.61H30.957a1.667,1.667,0,1,0,0,3.333h20.55a1.667,1.667,0,1,0,0-3.333Z",
    transform: "translate(18.193 20.42)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.7e026be8aa7a2dc4ba8096da8e551f78.svg";
export { ForwardRef as ReactComponent };